<template>
  <div class="app-container" style="line-height: 20px;">
    <div style="text-align: right;margin-bottom: 10px">
      <el-button
        size="small"
        type="primary"
        @click="downloadHeader()"
      >{{ $t('mdfeTranslate.DownloadBaseInvoiceBasicInformation') }}</el-button>
      <!--下载票据全部信息-->
      <el-button
        size="small"
        type="primary"
        @click="processingPDFData()"
      >{{ $t('mdfeTranslate.DownloadAllInvoiceInformation') }}</el-button>
    </div>
    <!-- PDF内容 - 保持原有template结构 -->
    <div id="pdfHeader">
      <div style="display: flex;color:#000;">
        <div style="flex: 1">
          <div style="display: flex;border: 1px solid #000;">
            <div style="flex: 1;padding: 10px; display: flex; flex-direction: column; justify-content: space-between;">
              <img
                id="ajlogo1" :src="require('@/assets/ajlogo1.svg')" style="width: 100%;"
                alt=""
              >
              <div style="font-weight: bold">
                <div>CNPJ</div>
                <div>{{ rowMDFEData.company.companyCnpj }}</div>
              </div>
            </div>
            <div style="flex: 1;padding: 10px;font-weight: bold">
              <div style="font-size: 18px">{{ rowMDFEData.company.companyName }}</div>
              <div style="margin: 5px 0;">{{ rowMDFEData.company.address }}, {{ rowMDFEData.company.number }}</div>
              <div style="margin: 5px 0;">{{ rowMDFEData.company.neighborhood }} - FONE: {{ rowMDFEData.company.telephone }}</div>
              <div style="margin: 5px 0;">{{ rowMDFEData.company.city }} - {{ rowMDFEData.company.state }} - CEP: {{ rowMDFEData.company.zipcode }}</div>
              <div style="margin: 5px 0;">{{ rowMDFEData.company.email }}</div>
              <div style="display: flex">
                <div style="flex: 1">
                  <div>IE</div>
                  <div>{{ rowMDFEData.company.ie }}</div>
                </div>
                <div style="flex: 1">
                  <div>RNTRC</div>
                  <div>{{ rowMDFEData.company.rntrc }}</div>
                </div>
              </div>
            </div>
          </div>
          <div style="display: flex; font-weight: bold;">
            <div style="flex: 1;border: 1px solid #000;padding: 10px">
              <div>ORIGEM PRESTAÇÃO</div>
              <div>{{ rowMDFEData.startCityName }} / {{ rowMDFEData.startUf }}</div>
            </div>
            <div style="flex: 1;border: 1px solid #000;padding: 10px">
              <div>PLACAS</div>
              <div>Tração: {{ rowMDFEData.vehiclePlate }} <span style="margin-left: 10px;">Reboque: {{ rowMDFEData.veicReboque }}</span></div>
            </div>
          </div>
          <div style="display: flex; font-weight: bold;">
            <div style="flex: 1;border: 1px solid #000;padding: 10px">
              <div>
                <div>DESTINO DA PRESTAÇÃO</div>
                <div>{{ rowMDFEData.endCityName }} / {{ rowMDFEData.endUf }}</div>
              </div>
            </div>
            <div style="flex: 1;padding: 10px;">
              <div>MOTORISTAS (CPF/NOME)</div>
              <div
                v-for="(item, index) in rowMDFEData.drivers"
                :key="index"
                style="padding: 10px 0"
              >
                <div>{{ item.cpf }}</div>
                <div>{{ item.name }}</div>
              </div>
            </div>
          </div>
        </div>
        <div style="flex: 1;border: 1px solid #000;">
          <div style="display: flex;">
            <div style="flex: 1; display: flex; flex-direction: column; justify-content: space-between;">
              <div style="font-size: 20px;font-weight: bold;text-align: center">D A M D F E</div>
              <div style="font-size: 16px;font-weight: bold;text-align: center">DOCUMENTO AUXILIAR DE MANIFESTO ELETRÔNICO DE DOCUMENTOS FISCAIS</div>
              <div style="display:flex;height: 54px;">
                <div style="flex: 1;border: 1px solid #000;">
                  <div style="font-weight: bold">SÉRIE</div>
                  <div>{{ rowMDFEData.serie }}</div>
                </div>
                <div style="flex: 1;border: 1px solid #000;">
                  <div style="font-weight: bold">NÚMERO</div>
                  <div>{{ rowMDFEData.documentNumber }}</div>
                </div>
                <div style="flex: 1;border: 1px solid #000;">
                  <div style="font-weight: bold">MODAL</div>
                  <div>{{ rowMDFEData.modal }}</div>
                </div>
                <div style="flex: 1;border: 1px solid #000;">
                  <div style="font-weight: bold">MODELO</div>
                  <div>{{ rowMDFEData.modelo }}</div>
                </div>
              </div>
            </div>
            <div style="width: 200px">
              <div style="border: 1px solid #000;padding: 5px;">
                <div style="font-weight: bold">FOLHA</div>
                <div>01/01</div>
              </div>
              <div style="border: 1px solid #000;padding: 5px;">
                <div style="font-weight: bold">DATA/HORA DE EMISSÃO</div>
                <div>{{ rowMDFEData.mdfeCreatDate }}</div>
              </div>
              <div style="border: 1px solid #000;padding: 5px;">
                <div style="font-weight: bold">Nº PROTOCOLO</div>
                <div>{{ rowMDFEData.protocolNumber }}</div>
              </div>
            </div>
          </div>
          <div>
            <div style="font-weight: bold;text-align: center;">CONTROLE DO FISCO</div>
            <div style="display: flex">
              <div style="flex: 1;">
                <img id="barcode">
              </div>
              <div>
                <div id="qrcode" style="width: 130px; height: 110px;" />
              </div>
            </div>
            <div>
              <div style="text-align: center">
                Chave de acesso para consulta em https://dfe-portal.svrs.rs.gov.br/MDFe/Consulta
              </div>
              <div style="text-align: center;font-weight: bold">
                {{ rowMDFEData.mdfeKey }}</div>
            </div>
          </div>
        </div>
      </div>
      <div style="display: flex;color:#000;text-align: center">
        <div style="flex: 1;border: 1px solid #000">
          <div style="font-weight: bold">Quantidade de CT-es</div>
          <div>{{ rowMDFEData.cteQuantity }}</div>
        </div>
        <div style="flex: 1;border: 1px solid #000">
          <div style="font-weight: bold">Valor Total do Frete</div>
          <div>{{ formatNumber(pdfData.totalFrete) }}</div>
        </div>
        <div style="flex: 1;border: 1px solid #000">
          <div style="font-weight: bold">Valor Total da Carga</div>
          <div>{{ formatNumber(rowMDFEData.productAmount) }}</div>
        </div>
        <div style="flex: 1;border: 1px solid #000">
          <div style="font-weight: bold">Peso Total da Carga</div>
          <div>{{ rowMDFEData.cargaPeso }}</div>
        </div>
        <div style="flex: 1;border: 1px solid #000">
          <div style="font-weight: bold">Valor Total do ICMS</div>
          <div>{{ formatNumber(pdfData.totalIcms) }}</div>
        </div>
      </div>
      <div style="border: 1px solid #000;color:#000;">
        <div style="font-weight: bold;font-size: 16px">Usuário: {{ rowMDFEData.userEmail }}</div>
        <ul>
          <li><span class="listItem" />SEGURADORA: {{ rowMDFEData.insuranceCompany }} NUM APOLICE SEGUROS: {{ rowMDFEData.policyNo }}</li>
          <li><span class="listItem" />AUTORIZACAO TRANSSAT: MOTORISTA {{ rowMDFEData.driverCpf }} - PLACA {{ rowMDFEData.vehiclePlate }}</li>
          <li><span class="listItem" />PLACA {{ rowMDFEData.vehiclePlate }} - RENAVAM {{ rowMDFEData.renavam }} - PROPRIETARIO
            {{ rowMDFEData.vehiclePropCnpj }} {{ rowMDFEData.vehiclePropName }} IE {{ rowMDFEData.company.ie }} - RNTRC {{ rowMDFEData.company.rntrc }}</li>
          <li><span class="listItem" />PLACA {{ rowMDFEData.veicReboque }} - RENAVAM {{ rowMDFEData.veicReboqueRenavam }}</li>
          <li><span class="listItem" />DATA/HORA DO INICIO DA VIAGEM: {{ rowMDFEData.mdfeStartDate }}</li>
          <li>
            <span class="listItem" />UFS DO PERCURSO:
            <span v-for="(item, index) in rowMDFEData.throughUF" :key="index">{{ item }}</span>
          </li>
        </ul>
      </div>
    </div>
    <div
      ref="virtualContainer"
      class="virtual-scroll-container"
      @scroll="handleScroll"
    >
      <div style="padding: 5px;font-weight: bold;text-align: center;border: 1px solid #000;color:#000;margin-top: 110px;">Gaiola: G5</div>
      <div class="virtual-scroll-placeholder" :style="{ height: totalHeight + 'px' }">
        <div
          class="virtual-scroll-content"
          :style="{ transform: `translateY(${offsetY}px)` }"
        >
          <div
            v-for="(item, index) in visibleItems"
            :key="visibleStartIndex + index"
            style="color:#000;font-size: 14px;border: 1px solid #000; margin-bottom: 10px;"
            class="pdfItem"
            :data-item-index="visibleStartIndex + index"
          >
            <div style="display:flex;">
              <div style="flex: 1;font-weight: bold;">
                <div style="border: 1px solid #000;height: 50px;">CTRC</div>
                <div style="padding: 0 5px">{{ 'VIA108388-1' }}</div>
              </div>
              <div style="flex: 1;font-weight: bold;">
                <div style="border: 1px solid #000;height: 50px;">CT-e</div>
                <div style="padding: 0 5px;line-height: 14px">{{ item.invoiceKey }}</div>
              </div>
              <div style="flex: 1;font-weight: bold;">
                <div style="border: 1px solid #000;height: 50px;">REMETENTE</div>
                <div style="padding: 0 5px">{{ item.remetente.cnpj }}</div>
              </div>
              <div style="flex: 1;font-weight: bold;">
                <div style="border: 1px solid #000;height: 50px;">DESTINATARIO</div>
                <div style="padding: 0 5px">{{ item.destinatario.name }}</div>
              </div>
              <div style="flex: 1;font-weight: bold;">
                <div style="border: 1px solid #000;height: 50px;">UF</div>
                <div style="padding: 0 5px">{{ item.endUf }}</div>
              </div>
              <div style="flex: 1;font-weight: bold;">
                <div style="border: 1px solid #000;height: 50px;">CIDADE DESTIN</div>
                <div style="padding: 0 5px">{{ item.endCity }}</div>
              </div>
              <div style="flex: 1;font-weight: bold;">
                <div style="border: 1px solid #000;height: 50px;">KgReal</div>
                <div style="padding: 0 5px">{{ item.peso }}</div>
              </div>
              <div style="flex: 1;font-weight: bold;">
                <div style="border: 1px solid #000;height: 50px;">KgCalc</div>
                <div style="padding: 0 5px">{{ item.peso }}</div>
              </div>
              <div style="flex: 1;font-weight: bold;">
                <div style="border: 1px solid #000;height: 50px;">QVOL</div>
                <div style="padding: 0 5px">1</div>
              </div>
              <div style="flex: 1;font-weight: bold;">
                <div style="border: 1px solid #000;height: 50px;">Val Mercad</div>
                <div style="padding: 0 5px">{{ formatNumber(item.productAmount) }}</div>
              </div>
              <div style="flex: 1;font-weight: bold;">
                <div style="border: 1px solid #000;height: 50px;">Val Frete</div>
                <div style="padding: 0 5px">{{ formatNumber(item.frete) }}</div>
              </div>
              <div style="flex: 1;font-weight: bold;">
                <div style="border: 1px solid #000;height: 50px;">Val ICMS</div>
                <div style="padding: 0 5px">{{ formatNumber(item.icmsAmount) }}</div>
              </div>
              <div style="flex: 1;font-weight: bold;">
                <div style="border: 1px solid #000;height: 50px;">T</div>
                <div style="padding: 0 5px">C</div>
              </div>
              <div style="flex: 1;font-weight: bold;">
                <div style="border: 1px solid #000;height: 50px;">SET</div>
                <div style="padding: 0 5px">761</div>
              </div>
            </div>
            <div style="display: flex;color:#000;font-weight: bold;padding: 10px">
              <div style="flex: 1">
                <span style="margin-right: 15px;">Doc Fisc / Vol :</span>
                {{ item.invoiceKey }}
              </div>
              <div style="width: 80px">/ 1</div>
            </div>
            <div style="display:flex;color:#000;font-weight: bold;padding: 10px">
              <div style="flex: 1">
                <span style="margin-right: 15px;">Nº AVERBACAO:</span>
                {{ item.averb }}
              </div>
              <div style="flex: 1">
                <span style="margin-right: 15px;">PEDIDO: </span>{{ item.packageNumber }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="pdfFooter" style="color:#000;margin-top: 20px;">
      <div style="display: flex;color:#000;margin-top: 20px;">
        <div style="flex: 1; border: 1px solid #000;padding-bottom: 40px;">
          SAIDA DATA/HORA
        </div>
        <div style="flex: 1;border: 1px solid #000;padding-bottom: 40px;">
          CHEGADA DATA/HORA
        </div>
        <div style="flex: 1;border: 1px solid #000;padding-bottom: 40px;">
          MOTORISTA/ASSINATURA
        </div>
        <div style="flex: 1;border: 1px solid #000;padding-bottom: 40px;">
          CONFERENTE/ASSINATURA
        </div>
        <div style="flex: 1;border: 1px solid #000;padding-bottom: 40px;">
          MANIFESTO OPERACIONAL -
          DESTINO
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import JsBarcode from 'jsbarcode';
import qrcode from 'qrcode-generator';
import html2canvas from 'html2canvas';
import JsPDF from 'jspdf';
import { Loading } from 'element-ui';
import { formatNumber } from '@/utils/tools';

export default {
  name: 'Pdf',
  props: {
    rowMDFEData: {
      type: Object,
      default: function() {
        return {};
      }
    },
    cteData: {
      type: Array,
      default: function() {
        return [];
      }
    },
    pdfData: {
      type: Object,
      default: function() {
        return {
          totalFrete: 0,
          totalIcms: 0
        };
      }
    }
  },
  data() {
    return {
      options: {
        lock: true,
        text: this.$t('organizationManage.GenerateImageWaitDownload'),
        spinner: 'el-icon-loading',
        background: 'rgba(255,255,255,0.8)',
        customClass: 'custom-loading-zIndex'
      },
      itemHeight: 220, // 每个item的预估高度
      containerHeight: 600, // 容器高度
      visibleItemCount: 10, // 可见的item数量
      visibleStartIndex: 0, // 可见区域的起始索引
      offsetY: 0, // 偏移量
      formatNumber
    };
  },
  computed: {
    // 计算总高度
    totalHeight() {
      return this.cteData.length * this.itemHeight;
    },

    // 计算可见的items
    visibleItems() {
      const start = this.visibleStartIndex;
      const end = Math.min(start + this.visibleItemCount, this.cteData.length);
      return this.cteData.slice(start, end);
    }
  },
  mounted() {
    this.generateAndBarcode();
    // 初始化容器高度
    this.updateContainerHeight();
  },
  methods: {
    // 下载头部信息
    async downloadHeader() {
      const doc = await this.createdPdf();
      doc.save(`MDFE_${this.rowMDFEData.mdfeKey}.pdf`);
    },
    async createdPdf() {
      const doc = new JsPDF({
        orientation: 'landscape',
        unit: 'mm',
        format: 'a4'
      });
      const startX = 5;
      let currentY = 5;
      // 页高
      const pageHeight = doc.internal.pageSize.height;
      // 页宽
      const pageWidth = doc.internal.pageSize.width;
      // 边框
      doc.rect(startX, currentY, pageWidth - 10, pageHeight - 10);
      const towWidth = pageWidth / 4;
      const svgElement = document.getElementById('ajlogo1');
      if (svgElement) {
        const canvas = await html2canvas(svgElement, {
          backgroundColor: null, // 透明背景
          scale: 2 // 提高清晰度
        });
        doc.addImage(canvas.toDataURL('image/png'), 'PNG', startX + 5, currentY + 5, towWidth - 15, 25);
      }
      doc.setFontSize(10);
      doc.setFont('helvetica', 'bold');
      doc.text(doc.splitTextToSize((this.rowMDFEData.company.companyName || ''), towWidth - 10), towWidth, currentY + 5);
      doc.text(doc.splitTextToSize((this.rowMDFEData.company.address || '') + ', ' + (this.rowMDFEData.company.number || ''), towWidth - 10), towWidth, currentY + 15);
      doc.text(doc.splitTextToSize(`${this.rowMDFEData.company.neighborhood || ''} - FONE: ${this.rowMDFEData.company.telephone || ''}`, towWidth - 10), towWidth, currentY + 25);
      doc.text(doc.splitTextToSize(`${this.rowMDFEData.company.city || ''} - ${this.rowMDFEData.company.state || ''} - CEP: ${this.rowMDFEData.company.zipcode || ''}`, towWidth - 10), towWidth, currentY + 35);
      doc.text(doc.splitTextToSize((this.rowMDFEData.company.email || ''), towWidth - 10), towWidth, currentY + 45);
      doc.text('CNPJ', startX + 5, currentY + 50);
      doc.text((this.rowMDFEData.company.companyCnpj || ''), startX + 5, currentY + 55);
      doc.text('IE', towWidth, currentY + 50);
      doc.text((this.rowMDFEData.company.ie || ''), towWidth, currentY + 55);
      doc.text('RNTRC', towWidth + 40, currentY + 50);
      doc.text((this.rowMDFEData.company.rntrc || ''), towWidth + 40, currentY + 55);
      doc.rect(pageWidth / 2, currentY, 0, currentY + 55);
      doc.rect(startX, currentY + 60, pageWidth / 2 - 5, 0);

      const threeWidth = (pageWidth / 2) / 3;
      doc.setFontSize(14);
      const DAMDFE = 'D A M D F E';
      const DAMDFEWidth = doc.getTextWidth(DAMDFE);
      doc.text(DAMDFE, pageWidth / 2 + ((threeWidth * 2 - DAMDFEWidth) / 2), currentY + 5);
      doc.setFontSize(10);
      const MANIFESTO = 'DOCUMENTO AUXILIAR DE MANIFESTO ELETRÔNICO';
      const FISCAIS = 'DE DOCUMENTOS FISCAIS';
      const MANIFESTOWidth = doc.getTextWidth(MANIFESTO);
      const FISCAISWidth = doc.getTextWidth(FISCAIS);
      doc.text(MANIFESTO, pageWidth / 2 + ((threeWidth * 2 - MANIFESTOWidth) / 2), currentY + 15);
      doc.text(FISCAIS, pageWidth / 2 + ((threeWidth * 2 - FISCAISWidth) / 2), currentY + 20);
      doc.rect(pageWidth / 2, currentY + 25, threeWidth * 2, 0);
      const width4 = threeWidth * 2 / 4;
      doc.setFont('helvetica', 'bold');
      doc.text('SÉRIE', pageWidth / 2 + 2, currentY + 30);
      doc.setFont('helvetica', 'normal');
      doc.text((this.rowMDFEData.serie || ''), pageWidth / 2 + 2, currentY + 35);
      doc.rect(pageWidth / 2 + width4, currentY + 25, 0, 13);
      doc.setFont('helvetica', 'bold');
      doc.text('NÚMERO', pageWidth / 2 + width4 + 2, currentY + 30);
      doc.setFont('helvetica', 'normal');
      doc.text((this.rowMDFEData.documentNumber || ''), pageWidth / 2 + width4 + 2, currentY + 35);
      doc.rect(pageWidth / 2 + width4 * 2, currentY + 25, 0, 13);
      doc.setFont('helvetica', 'bold');
      doc.text('MODAL', pageWidth / 2 + width4 * 2 + 2, currentY + 30);
      doc.setFont('helvetica', 'normal');
      doc.text((this.rowMDFEData.modal || ''), pageWidth / 2 + width4 * 2 + 2, currentY + 35);
      doc.rect(pageWidth / 2 + width4 * 3, currentY + 25, 0, 13);
      doc.setFont('helvetica', 'bold');
      doc.text('MODELO', pageWidth / 2 + width4 * 3 + 2, currentY + 30);
      doc.setFont('helvetica', 'normal');
      doc.text((this.rowMDFEData.modelo || ''), pageWidth / 2 + width4 * 3 + 2, currentY + 35);
      doc.rect(pageWidth / 2, currentY + 38, threeWidth * 2, 0);
      doc.rect(pageWidth / 2 + threeWidth * 2, currentY, 0, 38);
      doc.setFont('helvetica', 'bold');
      doc.text('FOLHA', pageWidth / 2 + threeWidth * 2 + 2, currentY + 5);
      doc.setFont('helvetica', 'normal');
      doc.text('01/01', pageWidth / 2 + threeWidth * 2 + 2, currentY + 10);
      doc.rect(pageWidth / 2 + threeWidth * 2, currentY + 13, threeWidth - 5, 0);
      doc.setFont('helvetica', 'bold');
      doc.text('DATA/HORA DE EMISSÃO', pageWidth / 2 + threeWidth * 2, currentY + 18);
      doc.setFont('helvetica', 'normal');
      doc.text((this.rowMDFEData.mdfeCreatDate || ''), pageWidth / 2 + threeWidth * 2 + 2, currentY + 23);
      doc.rect(pageWidth / 2 + threeWidth * 2, currentY + 25, threeWidth - 5, 0);
      doc.setFont('helvetica', 'bold');
      doc.text('Nº PROTOCOLO', pageWidth / 2 + threeWidth * 2 + 2, currentY + 30);
      doc.setFont('helvetica', 'normal');
      doc.text((this.rowMDFEData.protocolNumber || ''), pageWidth / 2 + threeWidth * 2 + 2, currentY + 35);
      doc.rect(pageWidth / 2 + threeWidth * 2, currentY + 38, threeWidth - 5, 0);

      doc.setFont('helvetica', 'bold');
      doc.text('ORIGEM PRESTAÇÃO', startX + 2, currentY + 65);
      doc.setFont('helvetica', 'normal');
      doc.text((this.rowMDFEData.startCityName || '') + ' / ' + (this.rowMDFEData.startUf || ''), startX + 2, currentY + 70);
      doc.rect(towWidth - 15, currentY + 60, 0, 13);
      doc.setFont('helvetica', 'bold');
      doc.text('PLACAS', towWidth - 13, currentY + 65);
      doc.setFont('helvetica', 'normal');
      doc.text(`Tração: ${this.rowMDFEData.vehiclePlate || ''} Reboque: ${this.rowMDFEData.veicReboque || ''}`, towWidth - 13, currentY + 70);
      // doc.text('GCJ9A8649', towWidth + 16, currentY + 70);
      // doc.text('Reboque: ', towWidth + 38, currentY + 70);
      // doc.text('DTD8E', towWidth + 54, currentY + 70);
      doc.rect(pageWidth / 2, currentY + 60, 0, 13);
      doc.rect(startX, currentY + 73, pageWidth / 2 - 5, 0);
      doc.setFont('helvetica', 'bold');
      doc.text('DESTINO DA PRESTAÇÃO', startX + 2, currentY + 78);
      doc.setFont('helvetica', 'normal');
      doc.text(`${this.rowMDFEData.endCityName || ''} / ${this.rowMDFEData.endUf || ''}`, startX + 2, currentY + 83);
      doc.rect(towWidth - 15, currentY + 73, 0, 34);
      doc.setFont('helvetica', 'bold');
      doc.text('MOTORISTAS (CPF/NOME)', towWidth - 13, currentY + 78);
      // doc.rect(towWidth - 15, currentY + 80, towWidth + 15, 0);
      doc.setFont('helvetica', 'normal');

      const drivers = this.rowMDFEData.drivers || [];
      drivers.map((item, index) => {
        doc.text(`${item.cpf}`, towWidth - 13, (index === 0 ? currentY + 84 : currentY + 98));
        doc.text(doc.splitTextToSize(`${item.name}`, towWidth + 13), towWidth - 13, (index === 0 ? currentY + 88 : currentY + 102));
      });

      // doc.text((this.rowMDFEData.driverCpf || ''), towWidth + 2, currentY + 83);
      // doc.text((this.rowMDFEData.driverName || ''), towWidth + 2, currentY + 88);

      // doc.rect(pageWidth / 2, currentY + 73, 0, 17);
      // doc.rect(startX, currentY + 90, pageWidth / 2 - 5, 0);

      doc.rect(pageWidth / 2, currentY + 73, 0, 34);
      doc.rect(startX, currentY + 107, pageWidth / 2 - 5, 0);

      doc.setFont('helvetica', 'bold');
      const FISCO = 'CONTROLE DO FISCO';
      const FISCOWidth = doc.getTextWidth(FISCO);
      doc.text(FISCO, pageWidth / 2 + ((pageWidth / 2 - FISCOWidth) / 2), currentY + 43);
      // 创建条形码canvas
      const barcodeCanvas = document.createElement('canvas');
      JsBarcode(barcodeCanvas, this.rowMDFEData.mdfeKey, {
        height: 50,
        displayValue: false
      });

      // 添加条形码到PDF
      const barcodeData = barcodeCanvas.toDataURL('image/png');
      const barcodeWidth = 100;
      const barcodeHeight = 30;
      doc.addImage(barcodeData, 'PNG', pageWidth / 2 + 5, currentY + 45, barcodeWidth, barcodeHeight);

      // 创建二维码canvas
      const qr = qrcode(0, 'M');
      qr.addData(this.rowMDFEData.qrCodePath);
      qr.make();

      const qrCanvas = document.createElement('canvas');
      const qrSize = 100;
      qrCanvas.width = qrSize;
      qrCanvas.height = qrSize;
      const ctx = qrCanvas.getContext('2d');

      // 绘制二维码
      for (let row = 0; row < qr.getModuleCount(); row++) {
        for (let col = 0; col < qr.getModuleCount(); col++) {
          ctx.fillStyle = qr.isDark(row, col) ? '#000000' : '#ffffff';
          ctx.fillRect(col * (qrSize / qr.getModuleCount()), row * (qrSize / qr.getModuleCount()),
            qrSize / qr.getModuleCount(), qrSize / qr.getModuleCount());
        }
      }

      // 添加二维码到PDF
      const qrData = qrCanvas.toDataURL('image/png');
      const qrWidth = 25;
      const qrHeight = 25;
      doc.addImage(qrData, 'PNG', pageWidth / 2 + barcodeWidth + 10, currentY + 47, qrWidth, qrHeight);
      doc.setFont('helvetica', 'normal');
      doc.text('Chave de acesso para consulta em https://dfe-portal.svrs.rs.gov.br/MDFe/Consulta', pageWidth / 2 + 2, currentY + 52 + qrHeight);
      const mdfeKeyWodth = doc.getTextWidth(this.rowMDFEData.mdfeKey);
      doc.setFont('helvetica', 'bold');
      doc.text(this.rowMDFEData.mdfeKey, pageWidth / 2 + ((pageWidth / 2 - mdfeKeyWodth) / 2), currentY + 56 + qrHeight);
      doc.rect(pageWidth / 2, currentY + 107, pageWidth / 2 - 5, 0);
      // eslint-disable-next-line require-atomic-updates
      currentY += 112;

      const width5 = pageWidth / 5;
      doc.text('Quantidade de CT-es', startX + 2, currentY);
      doc.setFont('helvetica', 'normal');
      doc.text((this.rowMDFEData.cteQuantity + '' || ''), startX + 2, currentY + 5);
      doc.rect(width5, currentY - 5, 0, 15);
      doc.setFont('helvetica', 'bold');
      doc.text('Valor Total do Frete', width5 + 2, currentY);
      doc.setFont('helvetica', 'normal');
      doc.text(formatNumber(this.pdfData.totalFrete), width5 + 2, currentY + 5);
      doc.rect(width5 * 2, currentY - 5, 0, 15);
      doc.setFont('helvetica', 'bold');
      doc.text('Valor Total da Carga', width5 * 2 + 2, currentY);
      doc.setFont('helvetica', 'normal');
      doc.text(formatNumber(this.rowMDFEData.productAmount), width5 * 2 + 2, currentY + 5);
      doc.rect(width5 * 3, currentY - 5, 0, 15);
      doc.setFont('helvetica', 'bold');
      doc.text('Peso Total da Carga', width5 * 3 + 2, currentY);
      doc.setFont('helvetica', 'normal');
      doc.text((this.rowMDFEData.cargaPeso + '' || ''), width5 * 3 + 2, currentY + 5);
      doc.rect(width5 * 4, currentY - 5, 0, 15);
      doc.setFont('helvetica', 'bold');
      doc.text('Valor Total do ICMS', width5 * 4 + 2, currentY);
      doc.setFont('helvetica', 'normal');
      doc.text(formatNumber(this.pdfData.totalIcms), width5 * 4 + 2, currentY + 5);
      doc.rect(startX, currentY + 10, pageWidth - 10, 0);

      // eslint-disable-next-line require-atomic-updates
      currentY += 10;
      doc.setFont('helvetica', 'bold');
      doc.text(`Usuário: ${this.rowMDFEData.userEmail || ''}`, startX + 2, currentY + 5);
      // doc.text((this.rowMDFEData.userEmail || ''), startX + 17, currentY + 5);
      doc.setFont('helvetica', 'normal');
      doc.setFillColor(0, 0, 0);
      doc.circle(startX + 3, currentY + 9, 1, 'F');
      doc.text(`SEGURADORA: ${this.rowMDFEData.insuranceCompany || ''} NUM APOLICE SEGUROS: ${this.rowMDFEData.policyNo || ''}`, startX + 5, currentY + 10);

      doc.circle(startX + 3, currentY + 14, 1, 'F');
      doc.text(`AUTORIZACAO TRANSSAT: MOTORISTA ${this.rowMDFEData.driverCpf || ''} - PLACA ${this.rowMDFEData.vehiclePlate || ''}`, startX + 5, currentY + 15);

      doc.circle(startX + 3, currentY + 19, 1, 'F');
      doc.text(`PLACA ${this.rowMDFEData.vehiclePlate || ''} - RENAVAM ${this.rowMDFEData.renavam || ''} - PROPRIETARIO ${this.rowMDFEData.vehiclePropCnpj || ''} ${this.rowMDFEData.vehiclePropName || ''} IE ${this.rowMDFEData.company.ie || ''} - RNTRC ${this.rowMDFEData.company.rntrc || ''}`, startX + 5, currentY + 20);

      doc.circle(startX + 3, currentY + 24, 1, 'F');
      doc.text(`PLACA ${this.rowMDFEData.veicReboque || ''} - RENAVAM ${this.rowMDFEData.veicReboqueRenavam || ''}`, startX + 5, currentY + 25);

      doc.circle(startX + 3, currentY + 29, 1, 'F');
      doc.text(`DATA/HORA DO INICIO DA VIAGEM: ${this.rowMDFEData.mdfeStartDate || ''}`, startX + 5, currentY + 30);

      doc.circle(startX + 3, currentY + 34, 1, 'F');
      doc.text('UFS DO PERCURSO:', startX + 5, currentY + 35);
      const throughUF = this.rowMDFEData.throughUF || [];
      throughUF.map((item, index) => {
        doc.text(`${item}`, (startX + 43) + index * 8, currentY + 35);
      });
      return doc;
    },
    // 下载pdf
    async processingPDFData() {
      const loadingInstance = Loading.service(this.options);
      await new Promise(resolve => setTimeout(resolve, 100));
      try {
        // 头部信息
        const doc = await this.createdPdf();

        // 添加新页面用于表格数据
        doc.addPage();
        const startX = 5;
        let currentY = 5;
        const pageHeight = doc.internal.pageSize.height;
        // 列宽
        const colWidths = [20, 55, 30, 30, 10, 25, 15, 15, 10, 20, 15, 15, 10, 15];
        const totalWidth = colWidths.reduce((sum, width) => sum + width, 0);
        // 标题
        doc.setFontSize(10);
        doc.setFont('helvetica', 'bold');
        doc.text('Gaiola: G5', totalWidth / 2, currentY + 4);
        // 边框
        doc.rect(startX, currentY, totalWidth, 6);
        // 插入空格使换行
        const insertSpaceAt = (str, position) => {
          if (position < 0 || position > str.length) {
            return str;
          }
          return str.slice(0, position) + ' ' + str.slice(position);
        };
        // 表头数据
        const headerData = ['CTRC', 'CT-e', 'REMETENTE', 'DESTINATARIO', 'UF', 'CIDADE DESTIN', 'KgReal', 'KgCalc', 'QVOL', 'Val Mercad', 'Val Frete', 'Val ICMS', 'T', 'SET'];
        this.cteData.forEach(item => {
          // 数据行 - 单个记录，但内容会在单元格内自动换行
          const invoiceKey = insertSpaceAt(item.invoiceKey, 30);
          const dataRow = [
            'VIA108388-1',
            invoiceKey,
            item.remetente.cnpj,
            item.destinatario.name,
            item.endUf,
            item.endCity,
            item.peso,
            item.peso,
            '1',
            formatNumber(item.productAmount),
            formatNumber(item.frete),
            formatNumber(item.icmsAmount),
            'C',
            '761'
          ];

          // 计算表头高度
          const headerHeight = this.calculateRowHeight(doc, headerData, colWidths, true);

          // 计算数据行高度
          const dataHeight = this.calculateRowHeight(doc, dataRow, colWidths, false);

          const totalHeight = headerHeight + dataHeight;
          if (currentY + totalHeight > pageHeight - 20) {
            doc.addPage();
            currentY = 10;
          }
          // 增加标题高度
          currentY += 6;
          // 绘制表格外边框
          doc.setLineWidth(0.5);
          doc.rect(startX, currentY, totalWidth, totalHeight);

          // 绘制表头
          this.drawRowWithCellWrapping(doc, headerData, colWidths, startX, currentY, headerHeight, true);
          // 绘制网格线
          this.drawGridLines(doc, colWidths, startX, currentY, headerHeight, 0);
          currentY += headerHeight;

          // 绘制数据行
          this.drawRowWithCellWrapping(doc, dataRow, colWidths, startX, currentY, dataHeight, false);
          currentY += dataHeight;

          // 底部信息
          // const infoY = currentY + totalHeight;
          this.drawBottomInfo(doc, startX, currentY, totalWidth, item);
          currentY += 20;
        });
        currentY += 10;
        // 列宽
        const footColWidths = [55, 55, 55, 55, 65];
        const footData = [
          'SAIDA DATA/HORA',
          'CHEGADA DATA/HORA',
          'MOTORISTA/ASSINATURA',
          'CONFERENTE/ASSINATURA',
          'MANIFESTO OPERACIONAL - DESTINO'
        ];
        // 绘制表格外边框
        doc.setLineWidth(0.5);
        doc.rect(startX, currentY, totalWidth, 25);
        // 绘制表头
        this.drawRowWithCellWrapping(doc, footData, footColWidths, startX, currentY, 25, true);
        // 绘制网格线
        this.drawGridLines(doc, footColWidths, startX, currentY, 25, 0);
        // 保存PDF
        doc.save(`MDFE_${this.rowMDFEData.mdfeKey}.pdf`);
      } catch (error) {
        this.$message.error(this.$t('mdfeTranslate.GeneratePDFFailed'));
      } finally {
        if (loadingInstance) {
          loadingInstance.close();
        }
      }
    },
    // 计算表头\数据行高度
    calculateRowHeight(doc, rowData, colWidths, isHeader) {
      let maxLines = 1;

      if (isHeader) {
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(8);
      } else {
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(8);
      }

      rowData.forEach((cellData, colIndex) => {
        if (cellData && cellData.toString().trim() !== '') {
          const lines = this.wrapTextInCell(doc, cellData.toString(), colWidths[colIndex] - 2);
          maxLines = Math.max(maxLines, lines.length);
        }
      });

      return Math.max(maxLines * 3.5 + 2, 10); // 最小高度10mm
    },

    wrapTextInCell(doc, text, maxWidth) {
      const lines = [];
      const words = text.split(' ');
      let currentLine = '';

      for (const word of words) {
        const testLine = currentLine + (currentLine ? ' ' : '') + word;
        const textWidth = doc.getTextWidth(testLine);

        if (textWidth <= maxWidth || currentLine === '') {
          currentLine = testLine;
        } else {
          if (currentLine) lines.push(currentLine);
          currentLine = word;

          // 如果单个单词太长，强制分割
          while (doc.getTextWidth(currentLine) > maxWidth && currentLine.length > 1) {
            let cutPoint = currentLine.length - 1;
            while (cutPoint > 0 && doc.getTextWidth(currentLine.substr(0, cutPoint)) > maxWidth) {
              cutPoint--;
            }
            if (cutPoint > 0) {
              lines.push(currentLine.substr(0, cutPoint));
              currentLine = currentLine.substr(cutPoint);
            } else {
              break;
            }
          }
        }
      }

      if (currentLine) {
        lines.push(currentLine);
      }

      return lines.length > 0 ? lines : [''];
    },
    // 绘制表头
    drawRowWithCellWrapping(doc, rowData, colWidths, startX, startY, rowHeight, isHeader) {
      let currentX = startX;

      if (isHeader) {
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(8);
      } else {
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(8);
      }

      rowData.forEach((cellData, colIndex) => {
        if (cellData && cellData.toString().trim() !== '') {
          const lines = this.wrapTextInCell(doc, cellData.toString(), colWidths[colIndex] - 2);

          lines.forEach((line, lineIndex) => {
            const textX = currentX + 1;
            const textY = startY + 4 + lineIndex * 3.5;
            doc.text(line, textX, textY);
          });
        }
        currentX += colWidths[colIndex];
      });
    },
    // 绘制网格线
    drawGridLines(doc, colWidths, startX, startY, headerHeight, dataHeight) {
      doc.setLineWidth(0.3);
      const totalWidth = colWidths.reduce((sum, w) => sum + w, 0);

      // 表头和数据行之间的水平线
      doc.line(startX, startY + headerHeight, startX + totalWidth, startY + headerHeight);

      // 垂直线
      let currentX = startX;
      for (let i = 0; i < colWidths.length - 1; i++) {
        currentX += colWidths[i];
        doc.line(currentX, startY, currentX, startY + headerHeight + dataHeight);
      }
    },
    // 底部信息
    drawBottomInfo(doc, startX, startY, totalWidth, data) {
      const infoHeight = 18;
      // 边框
      // doc.setLineWidth(0.5);
      doc.rect(startX, startY, totalWidth, infoHeight);

      // 内容
      doc.setFontSize(8);
      doc.setFont('helvetica', 'bold');
      doc.text('Doc Fisc / Vol:', startX + 2, startY + 6);
      doc.text(data.invoiceKey, startX + 25, startY + 6);
      doc.text('/ 1', startX + totalWidth - 12, startY + 6);

      // 分割线
      // doc.setLineWidth(0.3);
      doc.line(startX, startY + 9, startX + totalWidth, startY + 9);

      doc.text('Nº AVERBACAO:', startX + 2, startY + 14);
      doc.text(data.averb || '', startX + 28, startY + 14);
      doc.text('PEDIDO:', startX + 140, startY + 14);
      doc.text(data.packageNumber, startX + 160, startY + 14);
    },
    // 生成条形码和二维码
    async generateAndBarcode() {
      // 生成条形码和二维码
      await this.generateBarcode();
      await this.generateQRCode();
    },
    // 生成条形码
    async generateBarcode() {
      return new Promise((resolve, reject) => {
        try {
          JsBarcode('#barcode', this.rowMDFEData.mdfeKey, {
            height: 80,
            width: 1.5,
            displayValue: false
          });
          resolve();
        } catch (error) {
          reject(error);
        }
      });
    },

    // 生成二维码
    async generateQRCode() {
      return new Promise((resolve, reject) => {
        try {
          const qr = qrcode(0, 'M');
          qr.addData(this.rowMDFEData.qrCodePath);
          qr.make();

          const canvas = document.createElement('canvas');
          const size = 110;
          canvas.width = size;
          canvas.height = size;
          const ctx = canvas.getContext('2d');
          const cellSize = size / qr.getModuleCount();

          for (let row = 0; row < qr.getModuleCount(); row++) {
            for (let col = 0; col < qr.getModuleCount(); col++) {
              ctx.fillStyle = qr.isDark(row, col) ? '#000' : '#fff';
              ctx.fillRect(col * cellSize, row * cellSize, cellSize, cellSize);
            }
          }

          document.getElementById('qrcode').appendChild(canvas);
          resolve();
        } catch (error) {
          reject(error);
        }
      });
    },
    // 更新容器高度
    updateContainerHeight() {
      if (this.$refs.virtualContainer) {
        this.containerHeight = this.$refs.virtualContainer.clientHeight || 600;
        this.visibleItemCount = Math.ceil(this.containerHeight / this.itemHeight) + 2; // 多渲染几个item以确保滚动顺畅
      }
    },

    // 处理滚动事件
    handleScroll(event) {
      const scrollTop = event.target.scrollTop;
      const newStartIndex = Math.floor(scrollTop / this.itemHeight);

      // 只有当起始索引发生变化时才更新
      if (newStartIndex !== this.visibleStartIndex) {
        this.visibleStartIndex = newStartIndex;
        this.offsetY = newStartIndex * this.itemHeight;
      }
    }
  }
};
</script>

<style>
.custom-loading-zIndex {
  z-index: 3000 !important;
}

/* 进度显示样式 */
.progress-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 4001;
}

.progress-container {
  background: white;
  padding: 30px;
  border-radius: 8px;
  min-width: 300px;
  text-align: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.progress-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #333;
}

.progress-bar {
  width: 100%;
  height: 20px;
  background-color: #f0f0f0;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 10px;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #4CAF50, #45a049);
  border-radius: 10px;
  transition: width 0.3s ease;
}

.progress-text {
  font-size: 14px;
  color: #666;
}
</style>

<style scoped>
.virtual-scroll-container {
  height: 600px;
  overflow-y: auto;
  border: 1px solid #ddd;
  margin: 10px 0;
}

.virtual-scroll-placeholder {
  position: relative;
}

.virtual-scroll-content {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}
.listItem {
  display: inline-block;
  width: 5px;
  height: 5px;
  background: #000;
  border-radius: 50%;
  margin: 3px 5px;
}
</style>

